export function getDirections(
  locationId: string,
  destLat: number,
  destLng: number,
) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/directions?destLat=${destLat}&destLng=${destLng}`,
  }
}
